import { render } from "./Aside.vue?vue&type=template&id=a4e88fca&ts=true"
import script from "./Aside.vue?vue&type=script&lang=ts"
export * from "./Aside.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Nodejs\\MaysTekpanel\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__